module.exports = __webpack_public_path__ + "img/factoryplay_activacion_marcas_.768988c8.png";